import { render, staticRenderFns } from "./RoundArrowBack.vue?vue&type=template&id=6210bfca"
import script from "./RoundArrowBack.vue?vue&type=script&lang=js"
export * from "./RoundArrowBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports